import ApiService from "api/ApiService";
import { setLocalStorageValue } from "utils/localStorage";

interface EmailExistsResponse {
  exists: boolean;
}

interface LoginResopnse {
  success: boolean;
  access_token?: string;
  message?: string;
}

interface SignUpBody {
  username: string;
  email: string;
  password: string;

  // profile
  firstName: string;
  lastName: string;
  company: string;
  industry: string;
  role: string;

  // marketing
  outreach: string;
  currentSolution: string;
  keyChallenges: string;
  teamSize: string;

  // referral
  referralCode: string;
}

interface SignUpResponse {
  success: boolean;
  access_token?: string;
  message?: string;
}

interface ResetPasswordRequestResponse {
  success: boolean;
  message: string;
}

export default class AuthService {
  private static getAuthUrl(): string {
    return "auth";
  }

  public static async getEmailExists(
    email: string,
  ): Promise<EmailExistsResponse> {
    try {
      const response = await ApiService.request(
        {
          url: `${this.getAuthUrl()}/email_exists?email=${email}`,
          method: "GET",
        },
        false,
      );
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public static async getUsernameExists(
    username: string,
  ): Promise<EmailExistsResponse> {
    try {
      const response = await ApiService.request(
        {
          url: `${this.getAuthUrl()}/username_exists?username=${username}`,
          method: "GET",
        },
        false,
      );
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public static async login(
    email: string,
    password: string,
  ): Promise<LoginResopnse> {
    try {
      const response = await ApiService.request(
        {
          url: `${this.getAuthUrl()}/login`,
          method: "POST",
          data: {
            email,
            password,
          },
        },
        false,
      );

      // store the auth-token in localStorage
      const accessToken = response.access_token;
      const refreshToken = response.refresh_token;
      setLocalStorageValue(ApiService.authTokenKey, accessToken);
      setLocalStorageValue(ApiService.refreshTokenKey, refreshToken);

      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public static async signup(data: SignUpBody): Promise<SignUpResponse> {
    try {
      const response = await ApiService.request(
        {
          url: `${this.getAuthUrl()}/signup`,
          method: "POST",
          data: { ...data },
        },
        false,
      );

      // store the auth-token in localStorage
      const accessToken = response.access_token;
      const refreshToken = response.refresh_token;
      setLocalStorageValue(ApiService.authTokenKey, accessToken);
      setLocalStorageValue(ApiService.refreshTokenKey, refreshToken);

      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public static async resetPasswordRequest(
    email: string,
    reset_url: string,
  ): Promise<ResetPasswordRequestResponse> {
    try {
      const response = await ApiService.request(
        {
          url: `${this.getAuthUrl()}/request_password_reset`,
          method: "POST",
          data: { email, reset_url },
        },
        false,
      );

      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public static async resetPassword(
    token: string,
    password: string,
  ): Promise<ResetPasswordRequestResponse> {
    try {
      const response = await ApiService.request(
        {
          url: `${this.getAuthUrl()}/reset_password`,
          method: "POST",
          data: { token, password },
        },
        false,
      );

      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
